import { render, staticRenderFns } from "./IconCircleUser.vue?vue&type=template&id=c3c477ee&functional=true&"
import script from "./IconCircleUser.vue?vue&type=script&lang=js&"
export * from "./IconCircleUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports